import React, { Component } from 'react';
import { CMSPath } from '../../config/constant'
import { connect } from 'react-redux';

class SuccessFailScreen extends Component {


    render() {
        return (
            <section class="overlay">
                {
                    this.props.status ? 
                        <div class="overlay-window-container">
                            <div class="overlay-window no-bg success">
                                <div class="overlay-content">
                                    <div class="header">
                                    {
                                        this.props.showStatusTitle &&
                                            <div class="header-icon">
                                                <i class="fas fa-check"></i>
                                                <p>{this.props.statusTitle}</p>
                                            </div>
                                    }
                                        <div class="header-text">
                                            <h3 style = {{height:"10rem"}}>{this.props.statusMessage1}</h3>
                                        </div>
                                    </div>
                                    <div class="hotel-logo">
                                        <img src={`${CMSPath}${this.props.logo}`} style={{ fill: "#fff", maxHeight:"2rem" }} />
                                        {this.props.statusMessage2}
                                    </div>
                                </div>
                                <div class="overlay-controls">
                                    {/* <button class="button secondary btn-action align-left">Share your experience</button>
                                    <button class="button secondary btn-action align-left">Share feedback</button> */}
                                        <button onClick={this.props.continue} 
                                        style = {{
                                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                            color: this.props.menuColor.assetFontSelectorColor
                                        }}
                                        class="button">Continue</button>
                                </div>
                            </div>
                        </div>
                        :
                        <div class="overlay-window-container">
                            <div class="overlay-window no-bg error">
                                <div class="overlay-content">
                                    <div class="header">
                                        {
                                            this.props.showStatusTitle && 
                                            <div class="header-icon">
                                                <i class="fas fa-times"></i>
                                            <p>{this.props.statusTitle}</p>
                                        </div>
                                        }
                                        <div class="header-text">
                                            <h3 style={{fontSize: '1.3rem'}}>{this.props.statusMessage1}</h3>
                                        </div>
                                    </div>
                                    <div class="hotel-logo">
                                        <img src={`${CMSPath}${this.props.logo}`} style={{ fill: "#fff" }} />
                                        {this.props.statusMessage2}
                                </div>
                                </div>
                                <div class="overlay-controls">
                                    { this.props.showTryAgain && <button class="button" 
                                    style = {{
                                        backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                        color: this.props.menuColor.assetFontSelectorColor
                                    }}
                                    onClick={this.props.tryAgain}>{this.props.tryAgainButtonTexts ? `${this.props.tryAgainButtonTexts}` : 'Try again'}</button>}
                                    { this.props.showClose && <button class={`button ${this.props.showTryAgain && "secondary"}`} onClick={this.props.close}>{this.props.closeButtonTexts ? `${this.props.closeButtonTexts}` : 'Close'}</button>}
                                </div>
                            </div>
                        </div>
                }
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        billTotal: state.store.viewBill.billTotal,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        selectedGuest: state.store2.viewBill.selectedGuest,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        sucFailPopStatus: state.store2.viewBill.sucFailPopStatus,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        timeIntervalsBillDetail: state.store.home.clientConfig.extraConfigParam 
            ? state.store.home.clientConfig.extraConfigParam.EXPRESS_CHECKOUT_TIME_INTERVALS : "",
    }
}

export default connect(
    mapStateToProps,
    {

    }
)(SuccessFailScreen);